module.exports = __webpack_public_path__ + "static/EGR_FlashPage_4-b3a0aa1364c8f4c7ed0325c6bec49a8e.jpg";